import useSWR from "swr"
import axios from "axios"

const fetcher = (url) => axios.get(url).then((r) => r.data)

export default function useProductTypeGroupRepositories(params = {}) {
  const base = process.env.REACT_APP_INVENTORY_API_URL

  const query = new URLSearchParams(
    Object.entries(params).reduce((acc, [k, v]) => {
      if (v === null || v === undefined || v === "") return acc
      acc[k] = v
      return acc
    }, {})
  ).toString()

  const url = `${base}/product-type-groups${query ? `?${query}` : ""}`

  const { data, error, isLoading, mutate } = useSWR(url, fetcher)

  return {
    data,
    error,
    isLoading,
    mutate,
  }
}
